import { render, staticRenderFns } from "./EmailLead.vue?vue&type=template&id=841e91d8&"
import script from "./EmailLead.vue?vue&type=script&lang=js&"
export * from "./EmailLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports